import { Box, styled, IconButton, Typography } from '@mui/material';

export const PlayerInner = styled(Box)(({ theme }) => ({
  height: theme.spacing(9),
  background: theme.palette.grey[800],
  borderRadius: theme.spacing(1),
  padding: theme.spacing(0, 2),
}));

export const PlayerGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  height: '100%',
  gridTemplateColumns: `${theme.spacing(5)} ${theme.spacing(5)} 1fr`,
  gridTemplateRows: theme.spacing(5),
  alignItems: 'center',
  alignContent: 'center',
  gridGap: theme.spacing(1),

  paddingRight: theme.spacing(10),
  [theme.breakpoints.down('desktop')]: {
    paddingRight: theme.spacing(5),
  },
  [theme.breakpoints.down('md')]: {
    paddingRight: theme.spacing(1),
  },
}));

export const WaveformContainer = styled(Box)(({ theme }) => ({
  height: '100%',
  width: '100%',
  maxWidth: theme.spacing(87.5),
  justifySelf: 'center',
}));

export const PlayerControl = styled(IconButton)(() => ({
  padding: 0,
  height: '100%',
}));

export const PlayerControlIcon = styled(Box)(() => ({
  width: '95%',
  height: 'auto',
}));

export const DurationContainer = styled(Typography)(() => ({
  fontSize: 12,
}));
